import React from 'react';
import './Sidebar.css';
import { FaPen, FaCalendarAlt, FaRegEdit, FaLink, FaStickyNote, FaChartLine, FaShareAlt, FaUser, FaUserShield } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
const iconList = [
  <FaPen />,
  <FaCalendarAlt />,
  <FaRegEdit />,
  <FaLink />,
  <FaStickyNote />,
  <FaChartLine />,
  <FaShareAlt />,
  <FaUser />,
  <FaUserShield />,
  <FaUserShield />
];

const Sidebar = ({ menuItems, activeItem, onMenuItemClick }) => {
  const navigate = useNavigate();
  return (
    <div className="sidebar">
      <div className="logo">
        <a href="/">
        <img src="mbsays_logo.png" alt="Logo" />
        </a>
      </div>
      <ul className="menu">
        {menuItems.map((item) => (
  <li
    key={item.id}
    className={`menu-item ${activeItem === item.id ? 'active' : ''}`}
    onClick={() => {
      onMenuItemClick(item.id);
      navigate(`/${item.id}`);
      setTimeout(() => window.location.reload(), 0);
    }}
  >
    <span className={`menu-icon icon-${item.id}`}>{iconList[item.id]}</span>
    <span className="menu-text">{item.label}</span>
  </li>
))}
      </ul>
    </div>
  );
};

export default Sidebar;
